import { LABELLING_CATEGORY } from "../../LabellingField/Labelling/LabellingConstant";

export const DRAG_AND_DROP_CATEGORY = {
  DECORATIVE: "DECORATIVE",
  DRAGGABLE: "DRAGGABLE",
  DROPZONE: "DROPZONE",
};

export const DRAG_AND_DROP_ITEM_TYPE = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  ELLIPSE: "ELLIPSE",
  POLYGON: "POLYGON",
  RECTANGLE: "RECTANGLE",
};

export const ELEMENT_ORDER = [
  DRAG_AND_DROP_CATEGORY.DECORATIVE,
  DRAG_AND_DROP_CATEGORY.DROPZONE,
  DRAG_AND_DROP_CATEGORY.DRAGGABLE,
  LABELLING_CATEGORY.LABEL,
];
